// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2YrFF","rootSuccess":"CompleteLink_rootSuccess__1Va0Z","rootFailure":"CompleteLink_rootFailure__1RvSU","isDisabled":"CompleteLink_isDisabled__2Qis1"};